//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { checkAuthor, formatDate } from '@/utils/utils'
export default {
  props: {
    mounth: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      pictures: [],
      indexSelected: 0,
      offset: 0,
    }
  },
  methods: {
    checkVerification(item, author) {
      return checkAuthor(item, author)
    }
  },
  chimera: {
    getGallery () {
      const getParams = formatDate(new Date(), 'MM.YYYY').split('.')
      return {
        url: `/api/v1/gallery/getLoyaltyOpenGallery`,
        key: 'masterpiece-for-mir-items',
        auto: true,
        params: {
          month: getParams[0],
          year: getParams[1],
          lang: this.$i18n.locale || 'ru'
        },
        on: {
          success () {
            this.pictures = this.getGallery.data.data || []
          }
        }
      }
    }
  }
}
